import CustomModal from '@UI/CustomModal'
import { ReactComponent as CloseIcon } from '@assets/icons/Generals/close-red-x-icon.svg'
import { Button } from 'antd'
import { useChangesWithoutSaveModal } from './hooks/useChangesWithoutSaveModal'
import './styles.css'

const ChangesWithoutSaveModal = () => {

    const { showPrompt, loadingTemplate, cancelNavigation, handleOpenCloseModal } = useChangesWithoutSaveModal()

    return (
        <CustomModal
            destroyOnClose={true}
            className="custom-modal changes-without-save-modal"
            isOpenModal={showPrompt}
            onCancel={() => {
                cancelNavigation()
            }}
            width={500}
        >
            <div className="changes-without-save-modal-title">
                <CloseIcon width={64} height={64} />
                <span>Cambios sin guardar</span>
                <p>Tienes cambios sin guardar. Guarda para aplicarlos o descarta para salir sin guardar.</p>
            </div>
            <div className="changes-without-save-modal-buttons">
                <Button
                    className="btn-standard-white"
                    onClick={() => handleOpenCloseModal({ save: false })}
                    style={{
                        width: '133px',
                        borderRadius: '32px',
                    }}
                    loading={loadingTemplate}
                >
                    DESCARTAR
                </Button>
                <Button
                    className="btn-standard-green"
                    onClick={() => handleOpenCloseModal({ save: true })}
                    style={{
                        width: '133px',
                        borderRadius: '32px',
                    }}
                    loading={loadingTemplate}
                >
                    GUARDAR
                </Button>
            </div>
        </CustomModal>
    )
}

export default ChangesWithoutSaveModal
